var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEs = function SvgEs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    viewBox: "0 0 19 19"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#es_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#es_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AA151B",
    d: "M-5 0h29v5H-5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1BF00",
    d: "M-5 5h29v9H-5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA151B",
    d: "M-5 14h29v5H-5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "es_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "#fff",
    rx: 9.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "es_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-5 0h29v19H-5z"
  })))));
};
export default SvgEs;